import { FC, useEffect, useMemo } from "react";
import {
    TabPanelContainer,
    TabPanelHeader,
    TabPanelHeaderContainer,
    TabPanelSaveButtonWrapper,
    Text,
} from "./styles";
import { BrgButton, ButtonVariant, FlexBox, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { ProjectMetaBack } from "shared/components/ProjectMetaBack/ProjectMetaBack";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import { LayoutConst } from "core";

export const TabPanel: FC<{
    text?: string,
    secondaryText?: string,
    description?: string,
    disabled?: boolean,
    disableMargin?: boolean,
    customBg?: string,
    errors?: string[],
    onExit?: () => void,
    onSubmit?: () => void,
    onSecondaryClick?: () => void,
}> = ({
    text,
    secondaryText,
    description,
    errors,
    customBg,
    disabled,
    disableMargin,
    onExit,
    onSubmit,
    onSecondaryClick,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    const errorMessages = useMemo(() => {
        if (!errors) return [];
        return Array.isArray(errors) ? errors : [errors];
    }, [errors]);

    const tooltipProps = useMemo(
        () =>
            errorMessages.length
                ? {
                      'data-tip': errorMessages[0],
                      'data-for': navbarCreateTooltipProps.id,
                  }
                : {},
        [errorMessages],
    );

    const tooltipConfig = useMemo(() => {
        const { id: _omitId, className: _omitClass, ...styleProps } = getTooltipStyles(theme);
        return {
            ...styleProps,
            ...navbarCreateTooltipProps,
        };
    }, [theme]);

    useEffect(() => {
        if (errorMessages.length) {
            ReactTooltip.rebuild();
        }
    }, [errorMessages]);

    return (
        <TabPanelContainer disableMargin={disableMargin}>
            {onExit && (
                <ProjectMetaBack onBackClick={() => onExit?.()} />
            )}
            <TabPanelHeaderContainer>
                <FlexBox direction="column" directionMobile="column" align="flex-start">
                    <TabPanelHeader>{text}</TabPanelHeader>
                    {!!description && <Text>{description}</Text>}
                </FlexBox>
                {!!onSecondaryClick || !!onSubmit && (
                    <TabPanelSaveButtonWrapper
                    $fullWidth={isMobile}
                    $blockChildPointerEvents={!!disabled && errorMessages.length > 0}
                    {...tooltipProps}
                >
                    {onSecondaryClick && (
                        <BrgButton fullWidth={isMobile} onClick={onSecondaryClick} variant={ButtonVariant.Hollow}>
                            {secondaryText}
                        </BrgButton>
                    )}
                    {onSubmit && (
                        <BrgButton
                            fullWidth={isMobile}
                            disabled={disabled}
                            onClick={onSubmit}
                            variant={ButtonVariant.Filled}
                            {...(customBg && { customBg: customBg as `#${string}` })}
                        >
                            {t('teams.adminPage.simply.tabs.save')}
                        </BrgButton>
                    )}
                    <ReactTooltip {...tooltipConfig} />
                </TabPanelSaveButtonWrapper>
                )}
            </TabPanelHeaderContainer>
        </TabPanelContainer>
    );
};
import { FC, useEffect, useMemo } from "react";
import {
    TabPanelContainer,
    TabPanelHeader,
    TabPanelHeaderContainer,
    TabPanelSaveButtonWrapper,
    Text,
} from "./styles";
import { BrgButton, ButtonVariant, FlexBox, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { ProjectMetaBack } from "shared/components/ProjectMetaBack/ProjectMetaBack";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import { LayoutConst } from "core";

export const TabPanel: FC<{
    text?: string,
    secondaryText?: string,
    description?: string,
    disabled?: boolean,
    disableMargin?: boolean,
    customBg?: string,
    errors?: string[],
    onExit?: () => void,
    onSubmit?: () => void,
    onSecondaryClick?: () => void,
}> = ({
    text,
    secondaryText,
    description,
    errors,
    customBg,
    disabled,
    disableMargin,
    onExit,
    onSubmit,
    onSecondaryClick,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    const errorMessages = useMemo(() => {
        if (!errors) return [];
        return Array.isArray(errors) ? errors : [errors];
    }, [errors]);

    const tooltipProps = useMemo(
        () =>
            errorMessages.length
                ? {
                      'data-tip': errorMessages[0],
                      'data-for': navbarCreateTooltipProps.id,
                  }
                : {},
        [errorMessages],
    );

    const tooltipConfig = useMemo(() => {
        const { id: _omitId, className: _omitClass, ...styleProps } = getTooltipStyles(theme);
        return {
            ...styleProps,
            ...navbarCreateTooltipProps,
        };
    }, [theme]);

    useEffect(() => {
        if (errorMessages.length) {
            ReactTooltip.rebuild();
        }
    }, [errorMessages]);

    return (
        <TabPanelContainer disableMargin={disableMargin}>
            {onExit && (
                <ProjectMetaBack onBackClick={() => onExit?.()} />
            )}
            <TabPanelHeaderContainer>
                <FlexBox direction="column" directionMobile="column" align="flex-start">
                    <TabPanelHeader>{text}</TabPanelHeader>
                    {!!description && <Text>{description}</Text>}
                </FlexBox>
                {!!onSecondaryClick || !!onSubmit && (
                    <TabPanelSaveButtonWrapper
                    $fullWidth={isMobile}
                    $blockChildPointerEvents={!!disabled && errorMessages.length > 0}
                    {...tooltipProps}
                >
                    {onSecondaryClick && (
                        <BrgButton fullWidth={isMobile} onClick={onSecondaryClick} variant={ButtonVariant.Hollow}>
                            {secondaryText}
                        </BrgButton>
                    )}
                    {onSubmit && (
                        <BrgButton
                            fullWidth={isMobile}
                            disabled={disabled}
                            onClick={onSubmit}
                            variant={ButtonVariant.Filled}
                            {...(customBg && { customBg: customBg as `#${string}` })}
                        >
                            {t('teams.adminPage.simply.tabs.save')}
                        </BrgButton>
                    )}
                    <ReactTooltip {...tooltipConfig} />
                </TabPanelSaveButtonWrapper>
                )}
            </TabPanelHeaderContainer>
        </TabPanelContainer>
    );
};
